import { useEffect, useState } from "react";

export function usePrivateData(httpUrl: string, isHealthy: boolean, isAuthenticated: boolean) {
  const [data, setData] = useState<{ apiKey?: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }

    if (!isHealthy) {
      setError("Connection is not healthy");
      setLoading(false);
      return;
    }

    const fetchPrivateData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${httpUrl}/private/data`, {
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Unknown error");
        console.error("Failed to fetch private data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivateData();
  }, [httpUrl, isHealthy, isAuthenticated]);

  return { data, loading, error };
}
